const MAX_EPISODE_NUMBER = 20000;
const EPISODE_NUMBER_VALIDATION_MESSAGES = [
    "Episode number must be a whole number.",
    "Episode number cannot be negative.",
    "Episode number cannot be greater than 20,000."
];

/**
 * Checks whether rich text HTML has readable text.
 *
 * @param {string | null | undefined} html - Rich text HTML from the hidden field.
 * @returns {boolean} True when the value is effectively blank.
 */
export function isRichTextBlank(html) {
    if (!html) {
        return true;
    }

    const container = document.createElement("div");
    container.innerHTML = html;
    const plainText = (container.textContent || "").replace(/\u00A0/g, " ").trim();

    return plainText === "";
}

/**
 * Validates episode number input used in audio episode forms.
 *
 * @param {string | null | undefined} rawEpisodeNumber - Raw episode number input value.
 * @returns {string} Error message when invalid, otherwise empty string.
 */
export function getEpisodeNumberValidationError(rawEpisodeNumber) {
    if (rawEpisodeNumber === null || rawEpisodeNumber === undefined || rawEpisodeNumber === "") {
        return "";
    }

    const normalizedEpisodeNumber = String(rawEpisodeNumber).trim();
    if (normalizedEpisodeNumber === "") {
        return "";
    }

    // Keep this strict so values like 1e2/e-19 are rejected before submit.
    if (!/^[+-]?\d+$/.test(normalizedEpisodeNumber)) {
        return "Episode number must be a whole number.";
    }

    const parsedEpisodeNumber = Number(normalizedEpisodeNumber);
    if (parsedEpisodeNumber < 0) {
        return "Episode number cannot be negative.";
    }

    if (parsedEpisodeNumber > MAX_EPISODE_NUMBER) {
        return "Episode number cannot be greater than 20,000.";
    }

    return "";
}

/**
 * Checks if an error message came from episode number format/range validation.
 *
 * @param {string | null | undefined} errorMessage - Current UI error message.
 * @returns {boolean} True when this is one of the helper-generated validation messages.
 */
export function isEpisodeNumberValidationMessage(errorMessage) {
    return EPISODE_NUMBER_VALIDATION_MESSAGES.includes(errorMessage);
}
